module.exports = __webpack_public_path__ + "static/channels-xxl-5429bc57293a9ac982cea2e842b0bb08.svg";